import * as React from 'react';

const SvgCheckCircleOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M4.25 12.76a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0m8.25-9.75c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.366 9.75-9.75-4.365-9.75-9.75-9.75m3.61 7.935a.75.75 0 1 0-1.22-.872l-3.167 4.434a.1.1 0 0 1-.152.012l-1.54-1.54a.75.75 0 0 0-1.061 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgCheckCircleOutlined;
